import Price from '~/utils/Price';

import ComparativePriceProduct from './ComparativePriceProduct';

export default class ComparativePrice {
	price: Price;

	fromProducts: ComparativePriceProduct[];

	constructor(price: Price, fromProducts: ComparativePriceProduct[]) {
		this.price = price;
		this.fromProducts = fromProducts;
	}
}
